import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useSetRecoilState } from "recoil";
import { alertMessageState } from "src/atom/LoadingState";

const AlertComponent = ({ message, onClose, classVal, timing }) => {
  const [alertMsg, setAlertMsg] = useState("");
  const [alertClass, setAlertClass] = useState(false);
  const setAlertMessage = useSetRecoilState(alertMessageState);

  useEffect(() => {
    if (message !== "") {
      const parts = String(message).split("|");

      setAlertMsg(parts?.[0]);
      if (parts?.[1]) {
        setAlertClass(parts?.[1]);
      }
      const timer = setTimeout(
        () => {
          onClose();
          setAlertClass(false);
          setAlertMessage("");
        },
        timing ? timing : 3000
      );
      return () => clearTimeout(timer);
    }
  }, [message, onClose]);

  return (
    message !== "" && (
      <div
        style={{
          position: "fixed",
          top: "12%",
          right: "2%",
          width: "30%",
          zIndex: 9999,
        }}
      >
        <div
          className={`alert alert-dismissible fade show ${
            alertClass ? "alert-success" : "alert-danger"
          }`}
          role="alert"
        >
          {alertMsg}
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={onClose}
          ></button>
        </div>
      </div>
    )
  );
};

AlertComponent.propTypes = {
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  classVal: PropTypes.bool,
};

export { AlertComponent };
